/**
 * Homepage
 *
 * Main application page that controls routing and user authentication.
 * Displays the Welcome page if the user is not authenticated.
 * Once authenticated, it shows the main layout with header, footer,
 * and routes for features like upload, visualization, projects,
 * and resources.
 *
 * @returns The homepage layout with routing and authentication logic.
 */
import LineChart from "../components/visualization/LineChart.js";
import '../styles/App.css';
import React, { useState } from 'react';
import NotFoundPage from "./NotFoundPage.jsx";
import Footer from '../components/ui/Footer';
import Header from '../components/ui/Header';
import LandingPage from './LandingPage.jsx';
import WelcomePage from './WelcomePage.jsx';
import { Route, Routes } from 'react-router-dom';
import FileUpload from "../components/upload/fileUpload";
import { chartData } from "../components/visualization/ChartConfig.js";
import LogOut from './LogOut';
import Codebase from "../components/codebase/Codebase.jsx";
import CodebaseDetails from '../components/codebase/CodebaseDetails';
import CompareRuns from '../components/codebase/CompareRuns.jsx';
import Resources from "./Resources.jsx";
import PrivateRoute from "../routes/PrivateRoute.js";
import PublicRoute from "../routes/PublicRoute.js";


function Homepage() {
    const [data] = useState(chartData);

    return (
        <div className="min-h-screen flex flex-col bg-[#F7FAFC] text-[#0F172A] font-[Manrope]">
            <Header />
            <main className="flex-1">
                <Routes>

                    <Route element={<PublicRoute />}>
                        <Route path="/" element={<WelcomePage />} />
                    </Route>

                    <Route element={<PrivateRoute />}>
                        <Route path="/home" element={<LandingPage />} />
                        <Route path="/upload" element={<FileUpload />} />
                        <Route path="/visual" element={<LineChart chartData={data} />} />
                        <Route path="/projects" element={<Codebase />} />
                        <Route path="/codebase/:codebaseId" element={<CodebaseDetails />} />
                        <Route path="/compare" element={<CompareRuns />} />
                    </Route>

                    <Route path="/resources" element={<Resources />} />
                    <Route path="/logout" element={<LogOut />} />
                    <Route path="*" element={<NotFoundPage />} />

                </Routes>
            </main>
            <Footer />
        </div>
    );
}

export default Homepage;